import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCategoriesByCompanySelect from 'modules/categories/hooks/use-categories-by-company-select';
import useEditProduct, {
  EditProductProps,
} from 'modules/products/hooks/use-edit-product';
import {
  PriceModeEnum,
  ProductProps,
  translatedProductProps,
} from 'modules/products/types';
import productsKeys from 'modules/products/util/products-keys';
import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditProduct: React.FC = () => {
  const {id} = useParams();
  const {
    getInput,
    getSwitch,
    getTextArea,
    getSelect,
    getImagePicker,
    getPriceInput,
  } = useFormInputs();
  const accessControls = useAccessControls();
  const [companyId, setCompanyId] = useState<string | undefined>(
    accessControls.companyId ?? undefined,
  );
  const categoriesSelect = useCategoriesByCompanySelect(companyId);

  const handleSubmit = (data: ProductProps) => {
    const formData = new FormData();

    formData.append('name', data.name);
    formData.append('description', data.description ?? '');
    formData.append('companyId', data.companyId);
    formData.append('priceMode', data.priceMode);
    if (data.price) formData.append('price', String(data.price));
    formData.append('active', String(data.active));
    formData.append('categoryId', data.categoryId);
    if (data.subCategoryId)
      formData.append('subCategoryId', data.subCategoryId);
    if (data.image && (data.image as any) instanceof File)
      formData.append('image', data.image);

    return formData;
  };

  return (
    <Edition<EditProductProps>
      border
      {...{handleSubmit}}
      onFormStateChange={(data) => {
        if (data.companyId && data.companyId !== companyId)
          setCompanyId(data.companyId);
      }}
      inputs={[
        getInput({
          name: 'name',
        }),
        getTextArea({name: 'description'}),
        getSelect({
          name: 'priceMode',
          data: [
            {label: 'Fixo', value: PriceModeEnum.fixed},
            {label: 'Tamanho', value: PriceModeEnum.size},
            {label: 'Adicionais', value: PriceModeEnum.additionals},
          ],
        }),
        getPriceInput({
          name: 'price',
          hidden: (data) => data.priceMode !== PriceModeEnum.fixed,
        }),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'categoryId',
          data: categoriesSelect.data,
          isLoading: categoriesSelect.isLoading,
        }),
        getImagePicker({label: 'Imagem', name: 'image'}),
      ]}
      detailsUrl={`/products/${id}`}
      onSubmit={() => useEditProduct(id!)}
      translationKey={translatedProductProps}
      queryKey={productsKeys.details(id!)}
    />
  );
};

export default EditProduct;
